export default __webpack_public_path__ + "static/dazzling_dance-1a943809f3eb3595951dedb431252fc9.png";